export default "__VITE_ASSET__0h_46WWm__"